export type VisualQuality = "economy" | "balanced" | "high";

export interface Preferences {
  soundEnabled: boolean;
  reducedMotion: boolean;
  quality: VisualQuality;
}

const key = "urlcade:preferences:v1";

export function readPreferences(): Preferences {
  const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
  try {
    const saved = JSON.parse(localStorage.getItem(key) ?? "null") as Partial<Preferences> | null;
    return {
      soundEnabled: typeof saved?.soundEnabled === "boolean" ? saved.soundEnabled : true,
      reducedMotion: typeof saved?.reducedMotion === "boolean" ? saved.reducedMotion : prefersReduced,
      quality: saved?.quality === "economy" || saved?.quality === "high" ? saved.quality : "balanced",
    };
  } catch {
    return { soundEnabled: true, reducedMotion: prefersReduced, quality: "balanced" };
  }
}

export function writePreferences(preferences: Preferences): void {
  try { localStorage.setItem(key, JSON.stringify(preferences)); } catch { /* Storage may be disabled by the browser. */ }
}
